'use client';

import { Country } from '@order-mage/integration-sdk';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import { ComponentPropsWithRef } from 'react';
import { QueryApi } from '@/features/query/api';
import { cn } from '@/shared/lib/cn';
import { Dropdown } from '@/shared/ui/dropdown';
import './country-select.scss';

type Props = ComponentPropsWithRef<typeof Dropdown.Trigger>;
export const CountrySelect = ({ className, ...props }: Props) => {
    const t = useTranslations();
    const { data: venue } = useQuery(QueryApi.Venue.queries.Venue);
    const { data: country } = useQuery(QueryApi.Country.queries.GetCountry);
    const selectedCountry = (country as Country) || venue?.address?.country;
    const { mutateAsync } = useMutation(QueryApi.Country.mutations.ChangeCountry);

    const availableCountries = [venue?.address?.country].filter(Boolean);
    if (availableCountries.length <= 1) {
        return null;
    }

    const handleSelect = (country: string) => {
        mutateAsync(country);
    };

    return (
        <Dropdown>
            <Dropdown.Trigger className={cn('country-select__trigger', className)} {...props}>
                <div className="country-select__content">
                    <span className="country-select__label">{t('COUNTRY_SELECT.LABEL')}</span>
                    <span className="country-select__value">{t(`COUNTRIES.${selectedCountry}`)}</span>
                </div>
            </Dropdown.Trigger>
            <Dropdown.Content className="z-[1001]!">
                <Dropdown.Item
                    key={venue?.address?.country}
                    onSelect={() => handleSelect(venue?.address?.country || '')}
                    data-testid={`country-select-item-${venue?.address?.country?.toLowerCase()}`}
                    data-value={venue?.address?.country}
                >
                    {venue?.address?.country && t(`COUNTRIES.${venue.address.country}`)}
                </Dropdown.Item>
            </Dropdown.Content>
        </Dropdown>
    );
};
